<script setup lang="ts">
import { onBeforeMount, ref } from 'vue'

const props = defineProps<{
  availableFilters?: string[]
}>()

const emits = defineEmits<(e: 'changeFilter', filters: string[]) => void>()

const selectedFilters = ref<string[]>([])

const selectFilter = (filter: string) => {
  if (selectedFilters.value.includes(filter)) {
    selectedFilters.value = selectedFilters.value.filter((f) => f !== filter)
    emits('changeFilter', selectedFilters.value)
    return
  }

  selectedFilters.value.push(filter)
  emits('changeFilter', selectedFilters.value)
}

onBeforeMount(() => {
  const searchParams = new URLSearchParams(window.location.search)

  selectedFilters.value =
    searchParams.get('filter')?.toLowerCase().split(',') || []
})
</script>
<template>
  <div class="flex items-center justify-center font-sans">
    <div
      v-if="props.availableFilters && props.availableFilters.length > 1"
      class="mx-auto mt-2 flex flex-wrap items-center justify-center gap-2 text-center font-sans"
    >
      <button
        v-for="(filter, i) in props.availableFilters"
        :key="i"
        :class="
          selectedFilters.includes(filter)
            ? 'bg-primary text-white'
            : 'bg-white text-primary'
        "
        class="flex items-center justify-center rounded-full border-2 border-primary border-opacity-60 px-2.5 sm:hover:bg-primary sm:hover:text-white"
        @click="() => selectFilter(filter)"
      >
        {{ $t(`${filter}`) }}
      </button>
    </div>
  </div>
</template>
